import { render, staticRenderFns } from "./index00.vue?vue&type=template&id=39dc9d88&scoped=true&"
import script from "./index00.vue?vue&type=script&lang=js&"
export * from "./index00.vue?vue&type=script&lang=js&"
import style0 from "./index00.vue?vue&type=style&index=0&id=39dc9d88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dc9d88",
  null
  
)

export default component.exports